/**
 * Auth-related React Query key factory.
 */
import type { ProfilePictureSize } from './useProfilePicture';

export const authQueryKeys = {
  /** Defensive invalidation — auth user lives in AuthContext, not React Query today. */
  currentUser: ['currentUser'] as const,
  profilePicture: (userId: string, size: ProfilePictureSize = 'thumbnail') =>
    ['profilePicture', userId, size] as const,
  /** Prefix invalidation — matches all sizes for a user. */
  profilePictureByUser: (userId: string) => ['profilePicture', userId] as const,
};
